import { useState, useCallback } from 'react';

const usePagination = (fetchData, pageSize = 12) => {
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [pagination, setPagination] = useState({
    total: 0,
    current: 1,
    pageSize,
  });
  const wrapperedFetchData = useCallback(async (current: Number = 1) => {
    if (loading) return;
    setLoading(true);
    const pageParam = {
      ...pagination,
      current,
    };
    const query = {
      pageSize,
      pageIndex: current,
    };
    const { total, data } = await fetchData(query);
    setLoading(false);
    setDataSource(data);
    setPagination({
      ...pageParam,
      total,
    });
  }, [fetchData, loading, pagination]);
  const handlePaginationChange = ({ pagination: { current } }: Object) => {
    wrapperedFetchData(current);
  };

  return {
    loading,
    dataSource,
    pagination,
    wrapperedFetchData,
    handlePaginationChange,
  };
};

export default usePagination;
